import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ExpanderIcon extends BaseIcon {
  getChildren = () => [ <path fill={ this.getColor() }
                              d='M0 2l3 3 3-3z'/> ]
  getViewBox = () => '0 0 6 6'
}
